import { render, staticRenderFns } from "./OrderDraftItemNotes.vue?vue&type=template&id=7e31b9fa&"
import script from "./OrderDraftItemNotes.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports